<header class="sbc__head">
  <h6 class="sbc__title">
    <span class="sbc__title-icon" [style.color]="titleIconColor">
      <i [class]="titleIcon"></i>
    </span>
    {{ titleKey | translate }}
  </h6>
  @if (hasData) {
    <span class="sbc__count">
      <strong>{{ stats?.testsTaken }}</strong>
      <small>{{ 'DASHBOARD.TOTAL_TESTS' | translate }}</small>
    </span>
  }
</header>

<div class="sbc__body" [style.--accent]="titleIconColor">

  <div class="sbc__hero" [class.is-empty]="!hasData">
    <strong class="sbc__hero-num">
      {{ hasData ? avg : '—' }}<span *ngIf="hasData">%</span>
    </strong>
    <span class="sbc__hero-lbl">{{ 'DASHBOARD.AVERAGE_SCORE' | translate }}</span>
  </div>

  @if (hasData) {
    <div class="sbc__ratio">
      <div class="sbc__ratio-labels">
        <span class="sbc__ratio-lbl is-passed">
          <i class="fa-solid fa-check"></i>
          <strong>{{ stats?.testsPassed ?? 0 }}</strong>
          {{ 'DASHBOARD.PASSED' | translate }}
        </span>
        <span class="sbc__ratio-lbl is-failed">
          <i class="fa-solid fa-xmark"></i>
          <strong>{{ stats?.testsFailed ?? 0 }}</strong>
          {{ 'DASHBOARD.FAILED' | translate }}
        </span>
      </div>

      <div class="sbc__ratio-bar" aria-hidden="true">
        <span class="sbc__ratio-bar-passed" [style.width.%]="displayedPassedRatio"></span>
        <span class="sbc__ratio-bar-failed" [style.width.%]="displayedFailedRatio"></span>
      </div>

      <div class="sbc__ratio-foot">
        <i class="fa-solid fa-bullseye"></i>
        {{ 'DASHBOARD.PASS_RATE' | translate }}
        <strong>{{ successRate }}%</strong>
      </div>
    </div>
  } @else {
    <div class="sbc__empty">
      <i class="fa-solid fa-chart-simple"></i>
      <span>—</span>
    </div>
  }

</div>

@if (includeExtremes && (stats?.bestScore != null || stats?.worstScore != null)) {
  <footer class="sbc__extremes">
    @if (stats?.bestScore != null) {
      <span class="sbc__extreme is-best">
        <i class="fa-solid fa-arrow-up"></i>
        <strong>{{ stats?.bestScore | number:'1.0-0' }}%</strong>
        {{ 'DASHBOARD.BEST_SCORE' | translate }}
      </span>
    }
    @if (stats?.worstScore != null) {
      <span class="sbc__extreme is-worst">
        <i class="fa-solid fa-arrow-down"></i>
        <strong>{{ stats?.worstScore | number:'1.0-0' }}%</strong>
        {{ 'DASHBOARD.WORST_SCORE' | translate }}
      </span>
    }
  </footer>
}
